module.exports = __webpack_public_path__ + "img/general_flower.a646896b.svg";